'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var rotateOut = {
  from: {
    transformOrigin: 'center',
    opacity: 1
  },
  to: {
    transformOrigin: 'center',
    transform: (0, _utils.rotate3d)(0, 0, 1, 200),
    opacity: 0
  }
};
exports.default = rotateOut;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/rotate-out.js
// module id = 252
// module chunks = 54990529738226 257444579329143